{
  "featuredEvent": "Événement à l'affiche",
  "upcomingEvents": "Événements à venir",
  "rsvp": "RSVP",
  "dateAtTime": "{{date}} à {{time}}",
  "dateRange": "{{start}} - {{end}}",
  "descriptionFrameTitle": "Description de l'événement",
  "notFoundTitle": "Événement introuvable",
  "notFoundDescription": "Nous n'avons pas trouvé cet événement."
}
